import { Controller } from 'stimulus';

class PaginateController extends Controller {
  connect() {
    this.API_URL = this.data.get('api');
  }

  onMoreItemsClick(e) {
    const { nextPage } = e.target.dataset;

    this.toggleLoadingState(true);

    this.setPageForFilter(nextPage);

    this.fetchItems(nextPage)
      .then(PaginateController.extractItemsFromResponse)
      .then((res) => {
        const [items, pagination] = res;

        this.toggleLoadingState(false);

        $(this.itemsTarget).append(items.innerHTML);

        if (typeof pagination !== 'undefined') {
          $(this.moreItemsTarget).html(pagination.innerHTML);
        } else {
          $(this.moreItemsTarget).remove();
        }
      });
  }

  fetchItems(page) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: `${this.API_URL}?page=${page}`,
        success: resolve,
        error: reject,
      });
    });
  }

  setPageForFilter(page) {
    if (!this.hasPageTarget) return;

    this.pageTarget.value = page;
  }

  toggleLoadingState(state) {
    this.paginatorTarget.disabled = state;
    this.paginatorTarget.classList.toggle('is-loading', state);
  }

  static extractItemsFromResponse(response) {
    const $items = $(response).find('[data-target="paginate.items"]');
    const $pagination = $(response).find('[data-target="paginate.moreItems"]');

    if (!$items.length) {
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject('Missing paginate.items target in response');
    }

    return Promise.resolve([$items[0], $pagination[0]]);
  }
}

PaginateController.targets = [
  'page',
  'items',
  'moreItems',
  'paginator',
];

export default PaginateController;
